import React, { Component } from 'react';

import Lottie from 'react-lottie';

import animation from './animation.json';
import VerticalAlign from '../verticalAlign'
import './Spinner.scss';

export default class LoadingSpinner extends Component {

    render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animation,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };

        return (
            <VerticalAlign>
            <div className={this.props.className}>
                <Lottie
                    width={this.props.width ? this.props.width : 30}
                    options={defaultOptions}  />
            </div>
            </VerticalAlign>
        );
    }
}


LoadingSpinner.defaultProps = {
    className: 'loading-spinners'
};


// WEBPACK FOOTER //
// ./src/components/spinner/Spinner.js